import type { ConnectedUsersFilters } from "@/app/oauth/accounts/search";
import {
  createResourceKeys,
  type ResourceKeyParams,
} from "@/lib/resource-context";

export const oauthProvidersKeys = createResourceKeys("oauthProviders");

type ConnectedAccountsListParams = ResourceKeyParams & {
  filters: ConnectedUsersFilters;
  limit: number;
  offset: number;
};

const baseConnectedAccountsKeys = createResourceKeys("connectedAccounts");

export const connectedAccountsKeys = {
  ...baseConnectedAccountsKeys,

  list: ({ filters, limit, offset, ...rest }: ConnectedAccountsListParams) =>
    [
      ...baseConnectedAccountsKeys.list(rest),
      { filters, limit, offset },
    ] as const,
};
